{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"rotation": [0.7071068286895752, 0, 0, 0.7071068286895752],
			"scale": [0.5077568888664246, 0.27189263701438904, 1.1462239027023315],
			"translation": [0, 0.9722320437431335, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.003",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.6757367849349976, 0.842529296875, 0.863662838935852, 1],
				"metallicFactor": 0.5826771259307861,
				"roughnessFactor": 0.18897701799869537
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 52,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 52,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 52,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 84,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 624,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 624,
			"byteOffset": 624,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 416,
			"byteOffset": 1248,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 168,
			"byteOffset": 1664,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 1832,
			"uri": "iron.bin"
		}
	]
}
